var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Mobile",
    d: "M25.63,6.56H14.37c-1.72,0-3.13,1.4-3.13,3.13V30.31c0,1.72,1.4,3.13,3.13,3.13h11.25c1.72,0,3.13-1.4,3.13-3.12V9.69c0-1.72-1.4-3.13-3.13-3.13Zm-11.88,6.25h12.5v14.37H13.75V12.81Zm.63-3.75h11.25c.34,0,.63,.28,.63,.63v.63H13.75v-.63c0-.34,.28-.63,.63-.63Zm11.25,21.88H14.37c-.34,0-.63-.28-.63-.63v-.63h12.5v.63c0,.34-.28,.63-.63,.63Z",
    style: {
      fill: "#141344"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/Mobile-Icon.e883f4321fe6a4c2d0503e9bee280f41.svg";
export { ForwardRef as ReactComponent };